import { render } from "./NavItem.vue?vue&type=template&id=cfce0228&scoped=true"
import script from "./NavItem.vue?vue&type=script&lang=js"
export * from "./NavItem.vue?vue&type=script&lang=js"

import "./NavItem.vue?vue&type=style&index=0&id=cfce0228&scoped=true&lang=css"

import exportComponent from "/Users/sivasankarelango/Sivasankar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cfce0228"]])

export default __exports__